import { defaultAccentColorRamp } from "../appTheme";
import { tryGetHostApi } from "./externalApi";
// From VisualTheme
//  Dark = 0,
//  Light = 1,
//  HighContrastBlack = 2,
//  HighContrastWhite = 3,
// Default to Light(1)
export async function getVisualTheme() {
    const themeApi = await getHostThemeApi(2);
    if (themeApi) {
        const visualTheme = await themeApi.visualTheme;
        return visualTheme;
    }
    else {
        return 1;
    }
}
export async function getSystemTheme() {
    const themeApi = await getHostThemeApi();
    if (themeApi) {
        const themeColorString = await themeApi.getBasicThemeColorPair();
        return themeColorString || "";
    }
    else {
        return "";
    }
}
export async function getIsAnimationEnabled() {
    const themeApi = await getHostThemeApi();
    if (themeApi && themeApi.animationsEnabled) {
        return themeApi.animationsEnabled;
    }
    return true;
}
export async function addAnimationSettingChangedEventListener(animationSettingChangedCallback) {
    const themeApi = await getHostThemeApi();
    if (themeApi) {
        themeApi.addEventListener("animationsenabledchanged", animationSettingChangedCallback);
    }
}
export async function removeAnimationSettingChangedEventListener(animationSettingChangedCallback) {
    const themeApi = await getHostThemeApi();
    if (themeApi) {
        themeApi.removeEventListener("animationsenabledchanged", animationSettingChangedCallback);
    }
}
export async function getIsAutohideScrollbarsEnabled() {
    const themeApi = await getHostThemeApi();
    if (themeApi && themeApi.autoHideScrollBars) {
        return themeApi.autoHideScrollBars;
    }
    return true;
}
export async function addAutohideScrollbarsSettingChangedEventListener(autohideScrollbarsSettingChangedCallback) {
    const themeApi = await getHostThemeApi();
    if (themeApi) {
        themeApi.addEventListener("autohidescrollbarschanged", autohideScrollbarsSettingChangedCallback);
    }
}
export async function removeAutohideScrollbarsSettingChangedEventListener(autohideScrollbarsSettingChangedCallback) {
    const themeApi = await getHostThemeApi();
    if (themeApi) {
        themeApi.removeEventListener("autohidescrollbarschanged", autohideScrollbarsSettingChangedCallback);
    }
}
export async function getAccentColorRamp() {
    const themeApi = await getHostThemeApi();
    if (themeApi) {
        const accentColorRamp = await themeApi.accentColorRamp;
        return accentColorRamp || defaultAccentColorRamp;
    }
    else {
        return defaultAccentColorRamp;
    }
}
export async function addSystemThemeChangedEventListener(themeChangedCallback) {
    const themeApi = await getHostThemeApi();
    if (themeApi) {
        themeApi.addEventListener("themechanged", themeChangedCallback);
    }
}
export async function removeSystemThemeChangedEventListener(themeChangedCallback) {
    const themeApi = await getHostThemeApi();
    if (themeApi) {
        themeApi.removeEventListener("themechanged", themeChangedCallback);
    }
}
// Host api getters.  See HostInterop_h.h
export async function getHostThemeApi(minVersion = 1, targetVersion = 1) {
    return (await tryGetHostApi("Theme", minVersion, targetVersion));
}
